/* globals jQuery */

const $ = jQuery;

export default function( elm ) {
	const $carousel = $( elm );
	const $slidesWrap = $carousel.find( '.js-slides-wrap' );

	$slidesWrap.each( function() {
		const count = $( this ).data( 'count' ) || 3;

		const breakpoints = [];

		if ( count > 1 ) {
			breakpoints.push( {
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			} );
		}

		if ( count > 2 ) {
			breakpoints.push( {
				breakpoint: 700,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			} );
		}

		if ( count > 3 ) {
			breakpoints.push( {
				breakpoint: 800,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			} );
		}

		if ( $( this ).parents( '.wp-block-column' ).length > 0 ) {
			breakpoints.push( {
				breakpoint: 1000,
				settings: {
					slidesToShow: Math.ceil( count / 2 ),
					slidesToScroll: Math.ceil( count / 2 ),
				},
			} );
		}

		$( this ).slick( {
			infinite: true,
			slidesToShow: count,
			slidesToScroll: count,
			arrows: false,
			responsive: breakpoints,
		} );
	} );

	const $filters = $carousel.find( '.js-filter' );
	$filters.click( function() {
		$filters.removeClass( 'is-current' );
		const filter = $( this ).addClass( 'is-current' ).data( 'filter' );

		$slidesWrap.slick( 'slickUnfilter' );

		if ( filter === 'all' ) {
			return;
		}

		$slidesWrap.slick( 'slickFilter', `.in--${ filter }` );
	} );

	$carousel.find( '.js-prev' ).click( () => $slidesWrap.slick( 'slickPrev' ) );
	$carousel.find( '.js-next' ).click( () => $slidesWrap.slick( 'slickNext' ) );
}
